



































import { Vue, Component, Prop } from "vue-property-decorator";
import _ from "@/boot/lodash";

// Enums/Data
import { ProductTypes } from "@/data/enums/products";
import { UserMetaKeys } from "@/data/enums/users";
import { IProduct, ISelectedProduct } from "@/models/products";
import { mapState } from "vuex";
import { ListDisplayMode } from "@/data/constants";

interface INewSelectedProduct {
  id: IProduct["id"];
  category_id: IProduct["category_id"];
  name: IProduct["name"];
}

@Component({
  components: {
    "tree-view-select-products": () =>
      import(
        "@/components/app/admin/catalogue/products/multilevelCategories/select/treeViewSelectProducts.vue"
      ),
    "catalogue-product-search": () =>
      import("@/components/app/admin/catalogue/catalogueProductSearch.vue")
  },
  computed: {
    ...mapState({
      showTreeView: (state, getters) => {
        const m = getters[`user/meta`](UserMetaKeys.UI_CATALOGUE_DISPLAY_MODE);
        if ([ListDisplayMode.GRID].includes(m)) return false;
        return true;
      }
    })
  }
})
export default class SelectProductsModal extends Vue {
  // Props
  @Prop({ required: true })
  public selectedProducts!: ISelectedProduct[];

  @Prop({ default: false })
  public disableBundles!: boolean;

  @Prop({ default: () => [] })
  public disabledProducts!: IProduct["id"][];

  @Prop({ default: true })
  public isMultiselect!: boolean;

  @Prop({
    default: () => [ProductTypes.SINGLE_PRODUCT, ProductTypes.PRODUCT_BUNDLE]
  })
  public productTypes!: ProductTypes[];

  // Variables
  public showTreeView!: boolean;
  public isLoading = false;
  public isReloading = false;
  public requestError = false;

  public newSelectedProducts: INewSelectedProduct[] = [];
  public treeKey = "TV";

  public async created() {
    this.newSelectedProducts = _.map(this.selectedProducts, selectedProduct => {
      return _.pick(selectedProduct, [
        "id",
        "category_id",
        "name"
      ]) as INewSelectedProduct;
    });

    this.$bus.$on("refreshProductSearchTree", () => {
      this.refreshTreeView();
    });
  }

  public saveChanges() {
    this.$emit("success", this.newSelectedProducts);
    this.$emit("close");
  }

  public get isOption() {
    return this.productTypes.includes(ProductTypes.PRODUCT_OPTION);
  }

  public get isAttribute() {
    return this.productTypes.includes(ProductTypes.PRODUCT_ATTRIBUTE);
  }

  public selectProduct(selectedProduct, value) {
    if (!value) {
      this.newSelectedProducts = _.filter(
        this.newSelectedProducts,
        newSelectedProduct => newSelectedProduct.id !== selectedProduct.id
      );
    } else if (!_.some(this.newSelectedProducts, ["id", selectedProduct.id])) {
      if (!this.isMultiselect) this.newSelectedProducts = [];

      this.newSelectedProducts.push(selectedProduct);
    }
  }

  // Computed
  public get buttonIsDisabled() {
    return this.selectedProductsNotChanged;
  }

  public get title() {
    return this.$t("_action.select_object", {
      object: (this.isOption
        ? this.isMultiselect
          ? this.$t("_.product_options")
          : this.$t("_.product_option")
        : this.isAttribute
        ? this.isMultiselect
          ? this.$t("_.product_attributes")
          : this.$t("_.product_attribute")
        : this.isMultiselect
        ? this.$t("_.products")
        : this.$t("_.product")
      )
        .toString()
        .toLowerCase()
    });
  }

  public get selectedProductsNotChanged() {
    return _.isEqual(
      _.sortBy(_.map(this.selectedProducts, product => product.id)),
      _.sortBy(_.map(this.newSelectedProducts, newProduct => newProduct.id))
    );
  }

  public refreshTreeView() {
    this.treeKey = `TV_${this.$uuid()}`;
  }

  public beforeDestroy() {
    this.$bus.$off("refreshProductSearchTree");
  }
}
